export default {
  vi: {
    aChatConfirmDeleteHistory: 'Xóa toàn bộ lịch sử chat với {username}?',
    aChatDeleteHistoryTitle: 'Xóa lịch sử chat',
    aChatDeleting: 'Đang xóa...',
  },
  en: {
    aChatConfirmDeleteHistory: 'Delete the entire chat history with {username}?',
    aChatDeleteHistoryTitle: 'Delete chat history',
    aChatDeleting: 'Deleting...',
  },
  ko: {
    aChatConfirmDeleteHistory: '{username}님의 전체 채팅 기록을 삭제하시겠습니까?',
    aChatDeleteHistoryTitle: '채팅 기록 삭제',
    aChatDeleting: '삭제 중...',
  },
  ja: {
    aChatConfirmDeleteHistory: '{username}さんとのチャット履歴をすべて削除しますか？',
    aChatDeleteHistoryTitle: 'チャット履歴を削除',
    aChatDeleting: '削除中...',
  },
  zh: {
    aChatConfirmDeleteHistory: '确定要删除与 {username} 的全部聊天记录吗？',
    aChatDeleteHistoryTitle: '删除聊天记录',
    aChatDeleting: '删除中...',
  },
};
